import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete as Selectbox,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import EscalationService from "src/service/escalation";
import VehicleDetailsService from "src/service/vehicleDetails";
import TimeSlotService from "src/service/timeslot";
import LocationService from "src/service/location";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Point of Interest",
  },
];

const validationSchema = yup.object({
  vehicle_no: yup
    .string("Select vehicle no")
    .required("Vehicle No is Required"),
  shift_id: yup.string("Select Shift").required("Shift is Required"),
  poi_id: yup.string("Select Location").required("Location is Required"),
});

const Add_EscalationList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [vehicle_list, setVehicle_list] = useState([]);
  const fetch_vehicle_list = async () => {
    try {
      const res = await VehicleDetailsService.fetch_distict_vehicle({
        vehicle_type: sessionData?.data?.vehicle_type || "",
        district_id: sessionData?.data?.district_id || "",
        user_type: sessionData?.data?.user_type || "",
        user_id: sessionData?.data?.id || "",
      });

      setVehicle_list(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [timezone, settimezone] = useState([]);
  const fetch_timezone_data = async () => {
    try {
      const res = await TimeSlotService.get_slot_data({});
      settimezone(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [locationdata, setlocationdata] = useState([]);
  const fetch_locationdata = async () => {
    try {
      const res = await LocationService.get_location_list({});
      console.log("res.data===", res.data);
      setlocationdata(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_vehicle_list();
    fetch_timezone_data();
    fetch_locationdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    vehicle_no: "",
    shift_id: "",
    poi_id: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const payloadval = {
          vehicle_no: values.vehicle_no,
          shift_id: values.shift_id,
          poi_id: values.poi_id,
          c_by: sessionData.data.id,
        };

        try {
          const res = await EscalationService.add_escalation(payloadval);
          swal("Success", res.message, "success");
          setTimeout(() => {
            navigate("/Escalation");
          }, 1000);
        } catch (error) {
          swal("Error", error, "error");
        }
      },
    });

  return (
    <>
      <Breadcrumb title="Add Point of Interest" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Typography
              variant="h2"
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              Add Point of Interest
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginTop: "15px",
              marginBottom: "15px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/Escalation")}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="vehicle_no">
                    Vehicle Number <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="vehicle_no"
                    name="vehicle_no"
                    options={vehicle_list}
                    // getOptionLabel={(option) => option.vehicle_no}
                    getOptionLabel={(option) => `${option.vehicle_no}`}
                    value={
                      vehicle_list.find(
                        (vehicle_list) =>
                          vehicle_list.vehicle_no === values.vehicle_no
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "vehicle_no",
                          value: newValue?.vehicle_no || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                        helperText={touched.vehicle_no && errors.vehicle_no}
                        fullWidth
                        variant="outlined"
                        placeholder="Search or select a vehicle"
                      />
                    )}
                  />
                </Grid>

                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="shift_id">
                    Shift Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="shift_id"
                    name="shift_id"
                    options={timezone}
                    // getOptionLabel={(option) => option.vehicle_no}
                    getOptionLabel={(option) => `${option.shift_name}`}
                    value={
                      timezone.find(
                        (timezone) => timezone.id === values.shift_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "shift_id",
                          value: newValue?.id || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={touched.shift_id && Boolean(errors.shift_id)}
                        helperText={touched.shift_id && errors.shift_id}
                        fullWidth
                        variant="outlined"
                        placeholder="Search or select a shift"
                      />
                    )}
                  />
                </Grid>

                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="poi_id">
                    Location Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="poi_id"
                    name="poi_id"
                    options={locationdata}
                    // getOptionLabel={(option) => option.vehicle_no}
                    getOptionLabel={(option) =>
                      `${option.location_name} - [Radius - ${option.radius} - [${option.lat} | ${option.lng}]]`
                    }
                    value={
                      locationdata.find(
                        (locationdata) => locationdata.id === values.poi_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "poi_id",
                          value: newValue?.id || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={touched.poi_id && Boolean(errors.poi_id)}
                        helperText={touched.poi_id && errors.poi_id}
                        fullWidth
                        variant="outlined"
                        placeholder="Search or select a shift"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default Add_EscalationList;
